import { Box, Flex } from "@chakra-ui/react"

import { ImpersonationBanner } from "./ImpersonationBanner"
import Menu from "./Menu"

export const Layout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Flex height="100%" flexDir="column">
      <ImpersonationBanner />
      {/* Below lg the menu is a top bar above the content instead of a rail beside it. */}
      <Flex flexGrow={1} minH={0} flexDir={{ base: "column", lg: "row" }}>
        <Menu />
        <Box flexGrow={1} minW={0} minH={0} overflow="auto" backgroundColor="surfaceAlt">
          {children}
        </Box>
      </Flex>
    </Flex>
  )
}
